import { clampTo, extractImageFrames } from '../../tools';
import type { WavespeedModelConfig } from '../types';

export const blackForestLabsConfigs: Record<string, WavespeedModelConfig> = {
    'flux-3': {
        // https://wavespeed.ai/zh-CN/models/black-forest-labs/flux-3/text-to-video
        // https://wavespeed.ai/zh-CN/models/black-forest-labs/flux-3/image-to-video
        // https://wavespeed.ai/zh-CN/models/black-forest-labs/flux-3/start-end-to-video
        apiPath: ({ frameMode }) => {
            if (frameMode === 'first') {
                return '/black-forest-labs/flux-3/image-to-video';
            } else if (frameMode === 'first_last') {
                return '/black-forest-labs/flux-3/start-end-to-video';
            } else {
                return '/black-forest-labs/flux-3/text-to-video';
            }
        },
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, aspectRatio, duration, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    prompt: prompt,
                    aspect_ratio: aspectRatio === 'match' ? undefined : clampTo(aspectRatio || '16:9', ['21:9', '2:1', '16:9', '4:3', '1:1', '3:4', '9:16'] as const, '16:9'),
                    duration: clampTo(duration || 5, [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20] as const, 5),
                    resolution: clampTo(quality || '720p', ['720p', '1080p'] as const, '720p'),
                    // 首帧 URL
                    image: firstImage,
                    // 可选参数
                    generate_audio: typeof (providerOptions as any)?.audio === 'boolean' ? (providerOptions as any).audio : true,
                };
            // 首尾帧模式
            } else if (frameMode === 'first_last') {
                return {
                    prompt: prompt,
                    aspect_ratio: aspectRatio === 'match' ? undefined : clampTo(aspectRatio || '16:9', ['21:9', '2:1', '16:9', '4:3', '1:1', '3:4', '9:16'] as const, '16:9'),
                    duration: clampTo(duration || 5, [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20] as const, 5),
                    resolution: clampTo(quality || '720p', ['720p', '1080p'] as const, '720p'),
                    // 首帧 URL
                    start_image: firstImage,
                    // 尾帧 URL
                    end_image: lastImage,
                    // 可选参数
                    generate_audio: typeof (providerOptions as any)?.audio === 'boolean' ? (providerOptions as any).audio : true,
                };
            // 文生视频模式
            } else {
                return {
                    prompt: prompt,
                    aspect_ratio: clampTo(aspectRatio || '16:9', ['21:9', '2:1', '16:9', '4:3', '1:1', '3:4', '9:16'] as const, '16:9'),
                    duration: clampTo(duration || 5, [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20] as const, 5),
                    resolution: clampTo(quality || '720p', ['720p', '1080p'] as const, '720p'),
                    // 可选参数
                    generate_audio: typeof (providerOptions as any)?.audio === 'boolean' ? (providerOptions as any).audio : true,
                };
            }
        },
    },
};